module.exports = __webpack_public_path__ + "img/Path 28542.353a6db3.png";